import { useCallback, useState } from 'react';

import { useDrawingShapeContext } from '../../drawingShapeContext';

import { StoreModel } from '~/core/models';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { selectSelectedStore, updateSelectedStore } from '~/redux/slices/store';

export const useStoreSelection = () => {
  const [storeCandidate, setClickedStore] = useState<StoreModel | undefined>(
    undefined
  );
  const [
    isChangeStoreConfirmationModalOpen,
    setIsChangeStoreConfirmationModalOpen,
  ] = useState(false);

  const dispatch = useAppDispatch();
  const selectedStore = useAppSelector(selectSelectedStore);

  const {
    getters: { areThereShapesInTheDrawingArea },
  } = useDrawingShapeContext();

  const handleStoreSelection = useCallback(
    (store: StoreModel) => () => {
      if (store.companyId === selectedStore?.companyId) {
        return;
      }

      if (areThereShapesInTheDrawingArea && selectedStore) {
        setClickedStore(store);
        setIsChangeStoreConfirmationModalOpen(true);
      } else {
        dispatch(updateSelectedStore(store));
      }
    },
    [selectedStore, areThereShapesInTheDrawingArea, dispatch]
  );

  const confirmStoreChange = useCallback(() => {
    if (storeCandidate) {
      dispatch(updateSelectedStore(storeCandidate));
    }
    setIsChangeStoreConfirmationModalOpen(false);
    setClickedStore(undefined);
  }, [dispatch, storeCandidate]);

  const cancelStoreChange = useCallback(() => {
    setIsChangeStoreConfirmationModalOpen(false);
    setClickedStore(undefined);
  }, []);

  return {
    storeCandidate,
    handleStoreSelection,
    confirmStoreChange,
    cancelStoreChange,
    isChangeStoreConfirmationModalOpen,
  };
};
